<template>
    <v-container class="pa-4 text-center">
        <p class="display-1 font-weight-light">Riwayat Produk</p>
        <template>
            <div>
                <v-data-table
                    :headers="headers"
                    :items="listItem"
                    :loading="loading"
                    class="elevation-1"
                    color="green lighten-1"
                >
                <template v-slot:item.item_name="{ item }">
                  <span v-if="item.schedule"><b>{{ item.item_name }}</b> <br/> Mulai: {{ item.schedule.start.substring(0, 16) }} <br/> Selesai: {{ item.schedule.finish.substring(0, 16) }} </span>
                  <span v-else>{{ item.item_name }}</span>
                </template>
                <template v-slot:item.qty="{ item }">
                  <span v-if="item.schedule">{{item.qty}} Jam</span>
                  <span v-else>{{item.qty}} Pcs</span>
                </template>
                <template v-slot:item.no="{ item }">
                  {{(listItem.indexOf(item)+1) + '.'}}
                </template>
                <!-- <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>{{ item.status == 'APPROVED' ? 'UNPAID' : item.status }}</v-chip>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn outlined x-small fab color="teal" @click="getDetailOrder(item.id)">
                        <v-icon>info</v-icon>
                    </v-btn>
                </template> -->
                </v-data-table>
            </div>
        </template>
    </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, findIndex } from "lodash";
export default {
    name: "Pemesanan",
    data () {
      return {
        totalData: 0,
        loading: true,
        options: {},
        headers: [
          {
            text: 'No.',
            align: 'start',
            value: 'no',
            class: 'white--text'
          },
          {
            text: 'Nama',
            align: 'start',
            value: 'item_name',
            class: 'white--text'
          },
          {text: 'Jumlah',value: 'qty',class: 'white--text'},
          {text: 'Harga',value: 'harga_jual',class: 'white--text'},
          {text: 'Total Harga',value: 'total',class: 'white--text'},
          {text: 'Tanggal',value: 'created_at',class: 'white--text'}
          // {text: 'Action',value: 'action',class: 'white--text'},
        ],
      }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    computed:{
        ...mapState({
            listItem: state => state.items.listItem
        }),
    },
    mounted () {
      this.getDataFromApi()
    },
    methods: {
      ...mapActions({
        getRiwayatProduk: "items/getRiwayatProduk"
      }),
      ...mapMutations({
        setlistItem : "items/SET_LIST_ITEM"
      }),
      async getDataFromApi () {
        this.loading = true
        const response = await this.getRiwayatProduk()
        let dataItems = []

        if(response.status == 200){
            forEach(response.data.attributes, data => {
                data.qty = Number(data.qty)
                data.harga_jual = Number(data.harga_jual)
                data.total = data.qty*data.harga_jual
                dataItems.push(data)
            })

            this.setlistItem(dataItems)
            this.totalData = dataItems.length
        }else{
            console.log(response)
        }

        this.loading = false
      },
      // getColor (status) {
      //   if (status == 'APPROVED') return 'orange'
      //   else if (status == 'PARTIAL') return 'blue'
      //   else return 'green'
      // },
      // getDetailOrder(id){
      //   this.setIdDialogOrder(id)
      //   this.detailOrder()
      //   this.setDialogOrder(true)
      // }
    },
};
</script>
<style>
.v-data-table-header {
    background-color: #00897B;
}
</style>
